/**
 * Filtering fields that will only contribute to personal details
 * document completion.
 * @param fieldValueMap {Object}
 * @param fieldValueMap.value {Any}
 * @param fieldValueMap.errorList {String[]}
 * @returns {String[]}
 */
export function filterRequiredFieldsToBeIncluded(fieldValueMap) {
  let result = [];
  Object.entries(fieldValueMap).forEach(([fieldId, item]) => {
    if (item.required) {
      result.push(fieldId);
    }
  });

  return result;
}
